import "./Nav.css";
import React, { useEffect, useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";

function Nav() {
  const [show, handleShow] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        handleShow(true);
      } else {
        handleShow(false);
      }
    });
    return () => window.removeEventListener("scroll");
  }, []);
  return (
    <div className={`nav ${show ? "nav__black" : "nav__fixedTop"}`}>
      <img
        className="nav__logo"
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/2560px-Netflix_2015_logo.svg.png"
        alt=""
      />
      <div className="nav__avatar-arrow">
        <img
          className="nav__avatar"
          src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Netflix-avatar.png"
          alt=""
        />
        <IoMdArrowDropdown className="arrow" />
      </div>
    </div>
  );
}

export default Nav;
